import packageJson from '../../package.json'

export const GoogleMapsAPIKey = 'AIzaSyA8XoDV3JCW6yRChH1n4SGbbFQvqTljaTw'

export const APP_VERSION = packageJson.version || '1.0.0'
export const POCKETSUITE_USER_ID = '5e188478-a964-44e2-baa9-14109fe4cc0d'

export const STRIPE_API_KEY = import.meta.env.VITE_API_STRIPE_KEY || ''
export const REACT_HOST = import.meta.env.VITE_REACT_HOST || 'https://desktop.pocketsuite.io'
export const API_BASE = import.meta.env.VITE_API_HOST || 'https://app.pocketsuite.io'
export const WSS_BASE = import.meta.env.VITE_WSS_HOST || ''
export const BOOK_BASE = import.meta.env.VITE_BOOK_BASE || 'https://pocketsuite.io'
export const ENVIRONMENT = import.meta.env.MODE
export const IS_PRODUCTION = import.meta.env.PROD
export const IS_DEVELOPMENT = import.meta.env.DEV
export const IS_STAGING = ENVIRONMENT === 'staging'
export const PUBLIC_URL = import.meta.env.BASE_URL || ''
export const REQUEST_TIMEOUT_SEC = 120

export const MINUTES_PER_DAY = 1440

// local storage keys
export const LOCAL_STORAGE_DEVICE_ID_KEY = 'id'
export const LOCAL_STORAGE_LOGGED_IN_KEY = 'loggedIn'
export const LOCAL_STORAGE_USER_ID_KEY = 'userId'
export const LOCAL_STORAGE_INDUSTRIES_KEY = 'industries'
export const LOCAL_STORAGE_WATCHED_ONBOARDING_VIDEO = 'watchedPaymentsVideo'

// session storage keys
export const SESSION_STORAGE_RETURNED_KEY = 'returned'
export const SESSION_STORAGE_REPORT_STATE_KEY = 'reportState'
export const SESSION_STORAGE_DISMISS_CALENDAR_BANNER = 'dismissCalendarBanner'

// session storage cache key to indicate last server heartbeat, cleared on close & logout
export const SERVER_PING_DATE = 'serverLastSyncDate'

export const VERIFY_BUSINESS_FORM = '94b4cbca-e6aa-11e7-b874-040102a33301'
export const SHOW_TEXT_ME_DASHBOARD = 'show_text_me_dashboard'

export const PREMIUM_ID = 'f273f71c-688b-11e5-80b6-a0999b10cf73'
export const PREMIUM_PLUS_ID = '6495feb0-6ba2-11e5-abfb-a0999b10cf73'
export const PREMIUM_SUITE_ID = '926a698a-f90e-11e7-aade-a0999b10cf73'
export const PREMIUM_FRANCHISE_ID = '24fbbfa8-1779-11ef-beba-0401951f2a01'
export const PREMIUM_ANNUAL_ID = 'f18e11de-907f-11e7-afcd-a0999b10cf73'
export const PREMIUM_PLUS_ANNUAL_ID = 'f343007a-8fb2-11e7-97aa-a0999b10cf73'
export const PREMIUM_SUITE_ANNUAL_ID = 'b90247a1-f90e-11e7-9138-a0999b10cf73'
export const PREMIUM_FRANCHISE_ANNUAL_ID = '932f2bc6-1789-11ef-97e0-720c0bdae2e1'

export const PREMIUM_PRICE = 24.99
export const PREMIUM_LITE_PRICE = 14.99
export const PREMIUM_PLUS_PRICE = 34.99
export const PREMIUM_SUITE_PRICE = 99.99
export const PREMIUM_FRANCHISE_PRICE = 39.99
export const PREMIUM_ANNUAL_PRICE = 300
export const PREMIUM_PLUS_ANNUAL_PRICE = 420
export const PREMIUM_SUITE_ANNUAL_PRICE = 1200
export const PREMIUM_FRANCHISE_ANNUAL_PRICE = 480

export const dashboardKey = (tabName: string, userId?: string) =>
    `dashboard-${tabName}${userId ? `-${userId}` : ''}`

export const TRANSACTION_TTL = 60 * 1000 // 60 seconds for a full transaction
